module.exports = __webpack_public_path__ + "88dc9d065bffed0364d388076af47fba.jpg";